
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import PaymentDialog from '@/components/PaymentDialog';

const Hero = () => {
  const [showPayment, setShowPayment] = React.useState(false);

  // Optimized animation variants to reduce main thread work during scroll
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
  };

  return (
    // Added 'hero-critical-bg' class to match inline critical CSS in index.html
    <section className="hero-critical-bg relative py-16 lg:py-32 overflow-hidden">
      {/* Background Effects - Reduced complexity and opacity for better compositing */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" aria-hidden="true">
        <div className="absolute top-10 left-5 w-24 h-24 lg:w-72 lg:h-72 bg-[#FF6B35] rounded-full blur-[80px]"></div>
        <div className="absolute bottom-10 right-5 w-32 h-32 lg:w-96 lg:h-96 bg-blue-500 rounded-full blur-[80px]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-1 gap-12 items-center">
          <div className="text-center">
            <motion.h1
              initial="hidden"
              animate="visible"
              variants={fadeInUp}
              className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight hero-title-shim"
            >
              Get a <span className="text-[#FF6B35]">Discounted</span> CARFAX Report
              <br />
              <span className="text-2xl sm:text-3xl lg:text-4xl font-medium text-gray-300 block mt-4">Delivered Instantly</span>
            </motion.h1>

            <motion.p
              initial="hidden"
              animate="visible"
              variants={fadeInUp}
              transition={{ delay: 0.1 }}
              className="text-lg sm:text-xl text-gray-300 mb-8 max-w-2xl mx-auto"
            >
              Fast, reliable vehicle history reports delivered to your email. Avoid hidden problems and buy with confidence.
            </motion.p>

            <motion.div
              initial="hidden"
              animate="visible"
              variants={fadeInUp}
              transition={{ delay: 0.2 }}
              className="flex flex-col sm:flex-row gap-4 justify-center items-center"
            >
              <Button
                onClick={() => setShowPayment(true)}
                className="hero-btn-shim w-full sm:w-auto bg-[#FF6B35] hover:bg-[#FF5722] text-white px-8 py-6 text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
              >
                Order CARFAX Report
              </Button>
              <Button
                onClick={() => document.getElementById('compare').scrollIntoView({ behavior: 'smooth' })}
                variant="outline"
                className="w-full sm:w-auto border-2 border-white text-white hover:bg-white hover:text-[#0A1929] px-8 py-6 text-lg font-semibold rounded-lg transition-all duration-300"
              >
                Compare Alternatives
              </Button>
            </motion.div>
          </div>
        </div>
      </div>

      <PaymentDialog open={showPayment} onOpenChange={setShowPayment} />
    </section>
  );
};

export default Hero;
